var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.loaderClasses},[_c('svgicon',{attrs:{"name":"loader","original":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }